import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NgLetModule } from 'ng-let';
import { TranslateModule } from '@ngx-translate/core';

import { FormControlsModule } from '../admin/form-controls/form-controls.module';
import { PageLayoutModule } from '../global/page-layout';

import { EventListPage } from './event-list.page';
import { EventCreatePage } from './event-create.page';
import { EventDetailPage } from './event-detail.page';
import { EventEditPage } from './event-edit.page';
import { EventManageRegistrationsPage } from './event-manage-registrations.page';
import { VisibleCoOrganisersPipe } from './event-detail.page';
import { EventPointsPipe } from './event-list.page';
import { EventService } from './event.service';
import { CoOrganiserPickerComponent } from './co-organiser-picker.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        RouterModule,
        PageLayoutModule,
        FormControlsModule,
        NgLetModule,
        TranslateModule,
        CoOrganiserPickerComponent,
        VisibleCoOrganisersPipe,
        EventPointsPipe
    ],
    declarations: [EventListPage, EventCreatePage, EventDetailPage, EventEditPage, EventManageRegistrationsPage],
    exports: [EventListPage, EventCreatePage, EventDetailPage, EventEditPage, EventManageRegistrationsPage],
    providers: [EventService]
})
export class EventModule {}
